import { language_enum } from '@predium/enums';
import dayjs from 'dayjs';
import 'dayjs/locale/de';
import 'dayjs/locale/en-gb';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export const DAYJS_LOCALE: Record<language_enum, string> = {
  [language_enum.deDE]: 'de',
  [language_enum.enGB]: 'en-gb',
};

export function durationFromNow(date: string, language: language_enum) {
  const locale = DAYJS_LOCALE[language];

  return dayjs(date).locale(locale).fromNow();
}

/**
 * Serialises a date that may still be a `Date` instance (form values) or already an ISO string
 * (values coming off the wire) into an ISO string, e.g. for PostHog event properties.
 */
export function toIsoDateString(value: Date | string): string {
  return typeof value === 'string' ? value : value.toISOString();
}
